/** Cinema sync provider ids (match functions/sync-cinema adapters). */
export const CINEMA_PROVIDERS = [
    { id: 'hot-cinema', label: 'HOT CINEMA' },
    { id: 'cinema-city', label: 'סינמה סיטי' },
    { id: 'planet-cinema', label: 'פלאנט' },
    { id: 'lev', label: 'קולנוע לב' },
    { id: 'globus-premium', label: 'גלובוס / Premium' },
] as const;

export type CinemaProviderId = (typeof CINEMA_PROVIDERS)[number]['id'];

export const ASHKELON_AREA_HINTS = ['אשקלון', 'עומר', 'אשדוד', 'באר שבע'] as const;

/** Homepage cinema rail: Ashkelon only (no Ashdod / Beer Sheva). */
export const ASHKELON_HOME_HINTS = ['אשקלון', 'עומר', 'ashkelon'] as const;

/** Set to true when the public /cinema page is ready to launch. */
export const CINEMA_PUBLIC_ENABLED = false;

export function cinemaProviderLabel(id: string) {
    return CINEMA_PROVIDERS.find((p) => p.id === id)?.label ?? id;
}
